import { jsx as _jsx } from "react/jsx-runtime";
import { User } from "@air/next-icons";
import { memo } from "react";
import { InfoPanelDetailsSection } from "~/components/AssetModal/shared/components/InfoPanel/components/shared/InfoPanelDetailsSection";
import { InfoPanelDetailValue } from "~/components/AssetModal/shared/components/InfoPanel/components/shared/InfoPanelDetailValue";
import { isStringArrayMetadataType, isStringMetadataType } from "~/utils/iptcDataTypes";
export const InfoPanelCreator = /*#__PURE__*/ memo((param)=>{
    let { clipMetadata } = param;
    const creators = clipMetadata.find((metadata)=>metadata.fieldName === "Creator");
    const position = clipMetadata.find((metadata)=>metadata.fieldName === "AuthorsPosition");
    if (!creators || !isStringArrayMetadataType(creators) || creators.data.length === 0) {
        return null;
    }
    return /*#__PURE__*/ _jsx(InfoPanelDetailsSection, {
        Icon: User,
        title: "Creator",
        children: /*#__PURE__*/ _jsx(InfoPanelDetailValue, {
            value: creators.data.join(", "),
            additionalInfo: !!position && isStringMetadataType(position) ? position.data : undefined
        })
    });
});
InfoPanelCreator.displayName = "InfoPanelCreator";
